export default __webpack_public_path__ + "static/media/Alex_Pike_CV_2025.4acd7281.pdf";